'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_java$002elang$002e$002dString$002dIndex$002dOut$002dOf$002dBounds$002dException from "./java.lang.-String-Index-Out-Of-Bounds-Exception.js";
import * as $j_java$002emath$002e$002dBig$002dInteger from "./java.math.-Big-Integer.js";
import * as $j_java$002etime$002e$002dDate$002dTime$002dException from "./java.time.-Date-Time-Exception.js";
import * as $j_java$002etime$002eformat$002e$002dSign$002dStyle$0024 from "./java.time.format.-Sign-Style$.js";
import * as $j_java$002etime$002eformat$002einternal$002e$002dT$002dT$002dB$002dP$002dDate$002dTime$002dFormatter$002dBuilder$0024$002dNumber$002dPrinter$002dParser$0024 from "./java.time.format.internal.-T-T-B-P-Date-Time-Formatter-Builder$-Number-Printer-Parser$.js";
var $p;
function $ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__Ljava_time_temporal_TemporalField__I__I__Ljava_time_format_SignStyle__I__($thiz, field, minWidth, maxWidth, signStyle, subsequentWidth) {
  $thiz.gW = field;
  $thiz.dk = minWidth;
  $thiz.eh = maxWidth;
  $thiz.ei = signStyle;
  $thiz.gX = subsequentWidth;
  return $thiz;
}
export { $ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__Ljava_time_temporal_TemporalField__I__I__Ljava_time_format_SignStyle__I__ as $ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__Ljava_time_temporal_TemporalField__I__I__Ljava_time_format_SignStyle__I__ };
function $ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__Ljava_time_temporal_TemporalField__I__I__Ljava_time_format_SignStyle__($thiz, field, minWidth, maxWidth, signStyle) {
  $ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__Ljava_time_temporal_TemporalField__I__I__Ljava_time_format_SignStyle__I__($thiz, field, minWidth, maxWidth, signStyle, 0);
  return $thiz;
}
export { $ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__Ljava_time_temporal_TemporalField__I__I__Ljava_time_format_SignStyle__ as $ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__Ljava_time_temporal_TemporalField__I__I__Ljava_time_format_SignStyle__ };
/** @constructor */
function $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser() {
  this.gW = null;
  this.dk = 0;
  this.eh = 0;
  this.ei = null;
  this.gX = 0;
}
export { $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser as $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser };
$p = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser() {
}
export { $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser as $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser };
$h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser.prototype = $p;
$p.QY = (function() {
  return ((this.gX === (-1)) ? this : $ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__Ljava_time_temporal_TemporalField__I__I__Ljava_time_format_SignStyle__I__(new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser(), this.gW, this.dk, this.eh, this.ei, (-1)));
});
$p.YA = (function(subsequentWidth) {
  return $ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__Ljava_time_temporal_TemporalField__I__I__Ljava_time_format_SignStyle__I__(new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser(), this.gW, this.dk, this.eh, this.ei, ((this.gX + subsequentWidth) | 0));
});
$p.hr = (function(context, buf) {
  var valueLong = context.BF(this.gW);
  if ((valueLong === null)) {
    return false;
  }
  var value = this.V0(context, valueLong);
  var symbols = context.zO;
  if ($j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().ig(value, $j_java$002elang$002e$002dObject.$bL(0, (-2147483648)))) {
    var str = "9223372036854775808";
  } else {
    var $x_1 = $j_java$002elang$002e$002dObject.$uJ(value);
    var a_$_lo = $x_1.l;
    var a_$_hi = $x_1.h;
    var sign = (a_$_hi >> 31);
    var xlo = (a_$_lo ^ sign);
    var rlo = ((xlo - sign) | 0);
    var str = $j_java$002elang$002e$002dObject.$m_RTLong$().jv(rlo, (((a_$_hi ^ sign) + (((rlo >>> 0) < (xlo >>> 0)) | 0)) | 0));
  }
  if ((str.length > this.eh)) {
    throw $j_java$002etime$002e$002dDate$002dTime$002dException.$ct_Ljava_time_DateTimeException__T__(new $j_java$002etime$002e$002dDate$002dTime$002dException.$c_Ljava_time_DateTimeException(), ((((("Field " + this.gW) + " cannot be printed as the value ") + value) + " exceeds the maximum print width of ") + this.eh));
  }
  str = symbols.Or(str);
  var $x_2 = $j_java$002elang$002e$002dObject.$uJ(value);
  var x_$_lo = $x_2.l;
  var x_$_hi = $x_2.h;
  if ((x_$_hi >= 0)) {
    matchResult5: {
      var x9 = this.ei;
      var x$1 = $j_java$002etime$002eformat$002e$002dSign$002dStyle$0024.$s_Ljava_time_format_SignStyle$__EXCEEDS_PAD__Ljava_time_format_SignStyle();
      if (((x$1 === null) ? (x9 === null) : (x$1 === x9))) {
        if ((this.dk < 19)) {
          var $x_4 = $j_java$002elang$002e$002dObject.$uJ(value);
          var x$2_$_lo = $x_4.l;
          var x$2_$_hi = $x_4.h;
          var value$1 = $j_java$002etime$002eformat$002einternal$002e$002dT$002dT$002dB$002dP$002dDate$002dTime$002dFormatter$002dBuilder$0024$002dNumber$002dPrinter$002dParser$0024.$m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser$().Jz.a[this.dk];
          var hi = (value$1 >> 31);
          var $x_3 = ((x$2_$_hi === hi) ? ((x$2_$_lo >>> 0) >= (value$1 >>> 0)) : (x$2_$_hi > hi));
        } else {
          var $x_3 = false;
        }
        if ($x_3) {
          var c = symbols.iN;
          var str$1 = ("" + $j_java$002elang$002e$002dObject.$cToS(c));
          buf.r = (buf.r + str$1);
          break matchResult5;
        } else {
          break matchResult5;
        }
      }
      var x$3 = $j_java$002etime$002eformat$002e$002dSign$002dStyle$0024.$s_Ljava_time_format_SignStyle$__ALWAYS__Ljava_time_format_SignStyle();
      if (((x$3 === null) ? (x9 === null) : (x$3 === x9))) {
        var c$1 = symbols.iN;
        var str$2 = ("" + $j_java$002elang$002e$002dObject.$cToS(c$1));
        buf.r = (buf.r + str$2);
        break matchResult5;
      }
    }
  } else {
    matchResult6: {
      var x10 = this.ei;
      matchAlts1: {
        matchAlts2: {
          var x$5 = $j_java$002etime$002eformat$002e$002dSign$002dStyle$0024.$s_Ljava_time_format_SignStyle$__NORMAL__Ljava_time_format_SignStyle();
          if (((x$5 === null) ? (x10 === null) : (x$5 === x10))) {
            break matchAlts2;
          }
          var x$7 = $j_java$002etime$002eformat$002e$002dSign$002dStyle$0024.$s_Ljava_time_format_SignStyle$__EXCEEDS_PAD__Ljava_time_format_SignStyle();
          if (((x$7 === null) ? (x10 === null) : (x$7 === x10))) {
            break matchAlts2;
          }
          var x$9 = $j_java$002etime$002eformat$002e$002dSign$002dStyle$0024.$s_Ljava_time_format_SignStyle$__ALWAYS__Ljava_time_format_SignStyle();
          if (((x$9 === null) ? (x10 === null) : (x$9 === x10))) {
            break matchAlts2;
          }
          break matchAlts1;
        }
        var c$2 = symbols.jU;
        var str$3 = ("" + $j_java$002elang$002e$002dObject.$cToS(c$2));
        buf.r = (buf.r + str$3);
        break matchResult6;
      }
      var x$11 = $j_java$002etime$002eformat$002e$002dSign$002dStyle$0024.$s_Ljava_time_format_SignStyle$__NOT_NEGATIVE__Ljava_time_format_SignStyle();
      if (((x$11 === null) ? (x10 === null) : (x$11 === x10))) {
        throw $j_java$002etime$002e$002dDate$002dTime$002dException.$ct_Ljava_time_DateTimeException__T__(new $j_java$002etime$002e$002dDate$002dTime$002dException.$c_Ljava_time_DateTimeException(), (((("Field " + this.gW) + " cannot be printed as the value ") + value) + " cannot be negative according to the SignStyle"));
      }
    }
  }
  var i = 0;
  while ((i < ((this.dk - str.length) | 0))) {
    var c$3 = symbols.gU;
    var str$4 = ("" + $j_java$002elang$002e$002dObject.$cToS(c$3));
    buf.r = (buf.r + str$4);
    i = ((1 + i) | 0);
  }
  var str$5 = str;
  buf.r = (("" + buf.r) + str$5);
  return true;
});
$p.V0 = (function(context, value) {
  return ((context !== null) ? value : value);
});
$p.Pj = (function(context) {
  return ((context !== null) ? ((this.gX === (-1)) || (((this.gX > 0) && (this.dk === this.eh)) && (this.ei === $j_java$002etime$002eformat$002e$002dSign$002dStyle$0024.$s_Ljava_time_format_SignStyle$__NOT_NEGATIVE__Ljava_time_format_SignStyle()))) : ((this.gX === (-1)) || (((this.gX > 0) && (this.dk === this.eh)) && (this.ei === $j_java$002etime$002eformat$002e$002dSign$002dStyle$0024.$s_Ljava_time_format_SignStyle$__NOT_NEGATIVE__Ljava_time_format_SignStyle()))));
});
$p.gG = (function(context, text, position) {
  var _position = position;
  var length = $j_java$002elang$002e$002dObject.$dp_length__I(text);
  if ((_position === length)) {
    return (~_position);
  }
  if (((_position < 0) || (position > length))) {
    throw new $j_java$002elang$002e$002dString$002dIndex$002dOut$002dOf$002dBounds$002dException.$c_jl_StringIndexOutOfBoundsException();
  }
  var sign = $j_java$002elang$002e$002dObject.$dp_charAt__I__C(text, _position);
  var negative = false;
  var positive = false;
  if ((sign === context.k0.iN)) {
    if ((!this.ei.PQ(true, context.ej, (this.dk === this.eh)))) {
      return (~_position);
    }
    positive = true;
    _position = ((1 + _position) | 0);
  } else if ((sign === context.k0.jU)) {
    if ((!this.ei.PQ(false, context.ej, (this.dk === this.eh)))) {
      return (~_position);
    }
    negative = true;
    _position = ((1 + _position) | 0);
  } else if (((this.ei === $j_java$002etime$002eformat$002e$002dSign$002dStyle$0024.$s_Ljava_time_format_SignStyle$__ALWAYS__Ljava_time_format_SignStyle()) && context.ej)) {
    return (~_position);
  }
  var effMinWidth = ((context.ej || this.Pj(context)) ? this.dk : 1);
  var minEndPos = ((_position + effMinWidth) | 0);
  if ((minEndPos > length)) {
    return (~_position);
  }
  var $x_1 = ((context.ej || this.Pj(context)) ? this.eh : 9);
  var a = this.gX;
  var effMaxWidth = (($x_1 + ((a > 0) ? a : 0)) | 0);
  var total = $j_java$002elang$002e$002dObject.$bL(0, 0);
  var totalBig = null;
  var pos = _position;
  var pass = 0;
  var outerBreak = false;
  while (((!outerBreak) && (pass < 2))) {
    var a$1 = ((pos + effMaxWidth) | 0);
    var maxEndPos = ((a$1 < length) ? a$1 : length);
    var break$1 = false;
    while (((!break$1) && (pos < maxEndPos))) {
      var ch = $j_java$002elang$002e$002dObject.$dp_charAt__I__C(text, pos);
      pos = ((1 + pos) | 0);
      var digit = context.k0.Os(ch);
      if ((digit < 0)) {
        pos = ((pos - 1) | 0);
        if ((pos < minEndPos)) {
          return (~_position);
        }
        break$1 = true;
      }
      if ((!break$1)) {
        if ((((pos - _position) | 0) > 18)) {
          if ((totalBig === null)) {
            var $x_2 = $j_java$002elang$002e$002dObject.$uJ(total);
            var lVal_$_lo = $x_2.l;
            var lVal_$_hi = $x_2.h;
            totalBig = $j_java$002emath$002e$002dBig$002dInteger.$m_Ljava_math_BigInteger$().ed(lVal_$_lo, lVal_$_hi);
          }
          var $x_4 = $j_java$002emath$002e$002dBig$002dInteger.$m_Ljava_math_Elementary$();
          var $x_3 = totalBig.dv($j_java$002emath$002e$002dBig$002dInteger.$m_Ljava_math_BigInteger$().gP);
          var hi = (digit >> 31);
          totalBig = $x_4.ji($x_3, $j_java$002emath$002e$002dBig$002dInteger.$m_Ljava_math_BigInteger$().ed(digit, hi));
        } else {
          var $x_5 = $j_java$002elang$002e$002dObject.$uJ(total);
          var x$2_$_lo = $x_5.l;
          var x$2_$_hi = $x_5.h;
          var b0 = (65535 & x$2_$_lo);
          var b1 = ((x$2_$_lo >>> 16) | 0);
          var a0b0 = Math.imul(10, b0);
          var a0b1 = Math.imul(10, b1);
          var lo = ((a0b0 + (a0b1 << 16)) | 0);
          var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
          var hi$1 = ((Math.imul(10, x$2_$_hi) + ((c1part >>> 16) | 0)) | 0);
          var hi$2 = (digit >> 31);
          var lo$1 = ((lo + digit) | 0);
          var hi$3 = ((((hi$1 + hi$2) | 0) + (((lo$1 >>> 0) < (lo >>> 0)) | 0)) | 0);
          total = $j_java$002elang$002e$002dObject.$bL(lo$1, hi$3);
        }
      }
    }
    if (((this.gX > 0) && (pass === 0))) {
      var parseLen = ((pos - _position) | 0);
      var b = ((parseLen - this.gX) | 0);
      effMaxWidth = ((effMinWidth > b) ? effMinWidth : b);
      pos = _position;
      total = $j_java$002elang$002e$002dObject.$bL(0, 0);
      totalBig = null;
      pass = ((1 + pass) | 0);
    } else {
      outerBreak = true;
    }
  }
  if (negative) {
    if ((totalBig !== null)) {
      if (($j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().ig(totalBig, $j_java$002emath$002e$002dBig$002dInteger.$m_Ljava_math_BigInteger$().g7) && context.ej)) {
        return (~((_position - 1) | 0));
      }
      totalBig = totalBig.xI();
    } else {
      if (($j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().ig(total, 0) && context.ej)) {
        return (~((_position - 1) | 0));
      }
      var $x_6 = $j_java$002elang$002e$002dObject.$uJ(total);
      var x$4_$_lo = $x_6.l;
      var x$4_$_hi = $x_6.h;
      var lo$2 = ((-x$4_$_lo) | 0);
      var hi$4 = ((((-x$4_$_hi) | 0) - ((lo$2 !== 0) | 0)) | 0);
      total = $j_java$002elang$002e$002dObject.$bL(lo$2, hi$4);
    }
  } else if (((this.ei === $j_java$002etime$002eformat$002e$002dSign$002dStyle$0024.$s_Ljava_time_format_SignStyle$__EXCEEDS_PAD__Ljava_time_format_SignStyle()) && context.ej)) {
    var parseLen$2 = ((pos - _position) | 0);
    if (positive) {
      if ((parseLen$2 <= this.dk)) {
        return (~((_position - 1) | 0));
      }
    } else if ((parseLen$2 > this.dk)) {
      return (~_position);
    }
  }
  if ((totalBig !== null)) {
    if (($j_java$002emath$002e$002dBig$002dInteger.$m_Ljava_math_BitLevel$().kO(totalBig) > 63)) {
      totalBig = totalBig.TB($j_java$002emath$002e$002dBig$002dInteger.$m_Ljava_math_BigInteger$().gP);
      pos = ((pos - 1) | 0);
    }
    var $x_7 = totalBig.gB();
    return this.Qo(context, $x_7, _position, pos);
  }
  return this.Qo(context, total, _position, pos);
});
$p.Qo = (function(context, value, errorPos, successPos) {
  var $x_2 = this.gW;
  var $x_1 = $j_java$002elang$002e$002dObject.$uJ(value);
  return context.y8($x_2, $x_1.l, $x_1.h, errorPos, successPos);
});
$p.b = (function() {
  return ((((this.dk === 1) && (this.eh === 19)) && (this.ei === $j_java$002etime$002eformat$002e$002dSign$002dStyle$0024.$s_Ljava_time_format_SignStyle$__NORMAL__Ljava_time_format_SignStyle())) ? (("Value(" + this.gW) + ")") : (((this.dk === this.eh) && (this.ei === $j_java$002etime$002eformat$002e$002dSign$002dStyle$0024.$s_Ljava_time_format_SignStyle$__NOT_NEGATIVE__Ljava_time_format_SignStyle())) ? (((("Value(" + this.gW) + ",") + this.dk) + ")") : (((((((("Value(" + this.gW) + ",") + this.dk) + ",") + this.eh) + ",") + this.ei) + ")")));
});
function $isArrayOf_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.dJ)));
}
export { $isArrayOf_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser as $isArrayOf_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser };
var $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser, "java.time.format.internal.TTBPDateTimeFormatterBuilder$NumberPrinterParser", ({
  dJ: 1,
  av: 1
}));
export { $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser as $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser };
